var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    404: The requested page was not found\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }